import { ChangeDetectionStrategy, Component, model, output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { Asset } from 'shared/util-common';

import { FileDragDropComponent } from '../file-drag-drop/file-drag-drop.component';
import { FormFieldComponent } from '../form-field/form-field.component';
import { InputDirective } from '../input/input.directive';
import { LabelDirective } from '../label/label.directive';

@Component({
  selector: 'add-attachment',
  standalone: true,
  imports: [
    TranslocoModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    FileDragDropComponent,
    FormFieldComponent,
    LabelDirective,
    InputDirective,
    FormsModule,
  ],
  templateUrl: './add-attachment.component.html',
  styleUrls: ['./add-attachment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddAttachmentComponent {
  public attachment = model<Asset>(undefined);

  public assetChange = output<Asset>();
  public assetNameChanged = output<string>();

  protected handleFileChanged(file: File) {
    if (!file) {
      this.attachment.set(undefined);
      return;
    }

    this.attachment.set({
      file,
      name: file.name.split('.')[0] ?? '',
    });

    this.assetChange.emit(this.attachment());
  }

  protected handleFileNameChanged(name: string) {
    this.assetNameChanged.emit(name);
  }

  protected allowedTypes: string[] = [
    'png',
    'jpg',
    'jpeg',
    'gif',
    'bmp',
    'tif',
    'svg',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'ppt',
    'pptx',
    'pdf',
    'mp4',
    'avi',
    'wmv',
    'mpg',
    'mpeg',
    'mp3',
    'zip',
    'epub',
  ];
}
